export default {"src":"/_next/static/media/Bell.208fb3e8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};